import React, { useState } from "react";
import Card from "../../../components/Card";
import TextInput from "../../../components/TextInput";
import styles from "../ProductsDashboard.module.sass";
import cn from "classnames";
import { makeApiCall } from "../../../lib/api";
import toaster from "../../../utils/toaster";

import { useNavigate } from "react-router-dom";
import { ScaleLoader } from "react-spinners";
import Loader from "../../../components/Loader";

function AddingTaxOfficers({ setVisibleModal }) {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const handlesubmit = async (e) => {
    e.preventDefault();
    // const taskOfficeData = {
    //   name: e.target.value[0],
    //   code: e.target.value[1],
    // };

    const formData = new FormData();
    formData.append("name", e.target.name.value);
    formData.append("code", e.target.code.value);

    console.log(formData);
    // http://localhost:8888/api/v1/region/taxoffice
    setIsLoading(true);
    const response = await makeApiCall("/region/taxoffice", "POST", formData);
    // console.log(response)
    if (response.status === 200) {
      toaster(`${response.message}`, "success");
      e.target.reset();
      setVisibleModal(false);
      setIsLoading(false);
      //navigate("/taxoffices");
    } else {
      toaster(`An Error Occured`, "error");
      setIsLoading(false);
    }
  };

  return (
    <>
      <Card
        className={styles.card}
        title="Add Tax Officers"
        classTitle="title-blue"
      >
        <form onSubmit={handlesubmit}>
          <div style={{ marginBottom: "12px" }}>
            <TextInput
              className={``}
              name="name"
              type="text"
              placeholder="Enter  Name"
              required
              icon="profile-circle"
              // onChange={handleUserInputs}
            />
          </div>
          <div style={{ marginBottom: "12px" }}>
            <TextInput
              className={``}
              name="code"
              type="text"
              placeholder="Enter  Code"
              required
              icon="lock"
              // onChange={handleUserInputs}
            />
          </div>
          {/* <div style={{ marginBottom: '12px' }}>
          <TextInput
            className={``}
            name='username'
            type='text'
            placeholder='Enter Username'
            required
            icon='lock'
            // onChange={handleUserInputs}
          />
        </div>
        <div style={{ marginBottom: '12px' }}>
          <TextInput
            className={``}
            name='password'
            type='password'
            placeholder='Enter password'
            required
            icon='lock'
            // onChange={handleUserInputs}
          />
        </div> */}
          <button
            className={cn("button")}
            style={{ width: "100%" }}
            // onClick={handlesubmit}
            disabled={isLoading}
          >
            {isLoading ? (
              <ScaleLoader color="#fff" speedMultiplier={2} width={4} />
            ) : (
              "Add"
            )}
            {/* Add */}
          </button>
        </form>
      </Card>
    </>
  );
}

export default AddingTaxOfficers;
